<template>
  <div
      class="product-gallery-col"
      :class="{ 'full-width-gallery': !description || description.trim() === '' }"
  >
    <div class="gallery-amazon-container">

      <div class="main-image-wrap">
        <img :src="activeImage" :alt="productName" class="product-main-img" />
      </div>

    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ProductGallery',
  props: {
    images: { type: Array, required: true },
    activeImage: { type: String, required: true },
    productName: { type: String, required: true },
    description: { type: String, default: '' }
  }
});
</script>